<section class="hero">
  <div class="background">
    <div class="overlay"></div>
  </div>
  <div class="decorations">
    <div class="circle top-right"></div>
    <div class="circle bottom-left"></div>
  </div>

  <div class="auth-page-container">
    <div class="auth-card">
      <div class="auth-card__brand">
        <div class="auth-card__brand-icon"><mat-icon>point_of_sale</mat-icon></div>
        <span>Nova Point</span>
      </div>

      <div class="auth-card__icon">
        <mat-icon>lock_reset</mat-icon>
      </div>

      <h1>Forgot your password?</h1>
      <p class="subtitle">Enter your account's email address and we'll send you a code to reset your password.</p>

      <form [formGroup]="emailForm" (ngSubmit)="submit()" class="form">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Email address</mat-label>
          <input matInput formControlName="email" placeholder="you@example.com" type="email" autocomplete="email" />
          <mat-icon matPrefix>email</mat-icon>
          <mat-error *ngIf="emailForm.get('email')?.hasError('required')">Email is required</mat-error>
          <mat-error *ngIf="emailForm.get('email')?.hasError('email')">Enter a valid email</mat-error>
        </mat-form-field>

        <button mat-raised-button type="submit" class="submit-button" [disabled]="!emailForm.valid || loading">
          @if (loading) {
            <mat-spinner diameter="20" class="inline-spinner"></mat-spinner>
          } @else {
            Send reset code
          }
        </button>
      </form>

      <a routerLink="/landing" class="back-link">Back to login</a>
    </div>
  </div>
</section>
